// src/components/CamposCustomizados/CamposCustomizados.js
// Listagem de campos customizados (definição): nome, tipo documento, tipo_campo (Inteiro, Decimal, Data, Cadastro), situacao.
// Acesso apenas para usuários com permissão campos_customizados (rota protegida + item de menu por permissão).
import React, { useEffect, useState, useCallback, useContext } from "react";
import api, { BASE_URL } from "../../Utils/api";
import CamposCustomizadosModal from "./CamposCustomizadosModal";
import GridPadrao from "../GridPadrao/GridPadrao";
import PageHeader from "../PageHeader/PageHeader";
import { GlobalContext } from "../../Utils/GlobalContext";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";


const CamposCustomizados = () => {
  const { toast, confirm } = useFeedback();
  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");

  const [campos, setCampos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedCampo, setSelectedCampo] = useState(null);

  const columns = [
    { Header: "ID", accessor: "id" },
    {
      Header: "Nome",
      accessor: "descricao",
      Cell: ({ row }) => row.descricao || row.nome_campo || "—",
    },
    {
      Header: "Tipo Documento",
      accessor: "tipo_documento_descricao",
      Cell: ({ row }) => row.tipo_documento_descricao || row.tipo_documento_nome || "—",
    },
    { Header: "Tipo do campo", accessor: "tipo_campo" },
    { Header: "Situação", accessor: "situacao" },
  ];

  const fetchCampos = useCallback(async () => {
    if (!entidadeID) return;
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/camposCustomizados/ListarCamposCustomizados/${entidadeID}`
      );
      const lista = Array.isArray(data?.data) ? data.data : [];
      setCampos(lista);
    } catch (err) {
      console.error("Erro ao buscar campos customizados:", err);
      setCampos([]);
    }
  }, [entidadeID]);

  useEffect(() => {
    fetchCampos();
  }, [fetchCampos]);

  const handleAdd = () => {
    setSelectedCampo(null);
    setShowModal(true);
  };

  const handleEdit = (campo) => {
    setSelectedCampo(campo);
    setShowModal(true);
  };

  const handleExcluir = async (campo) => {
    if (campo.tem_respostas === "S") {
      toast.warning("Não é possível excluir pois o campo customizado já foi utilizado.");
      return;
    }
    const ok = await confirm(`Tem certeza que deseja excluir o campo "${campo.nome_campo || campo.nome}"?`);
    if (!ok) return;
    try {
      await api.delete(
        `${BASE_URL}/api/camposCustomizados/ExcluirCampoCustomizado/${campo.id}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );
      fetchCampos();
    } catch (err) {
      console.error("Erro ao excluir campo customizado:", err);
      toast.error(err.response?.data?.message || "Erro ao excluir campo. Tente novamente.");
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedCampo(null);
    fetchCampos();
  };

  return (
    <div>
      <PageHeader titulo="Campos Customizados" path="/CamposCustomizados" />

      <GridPadrao
        columns={columns}
        data={campos}
        onEdit={handleEdit}
        onAdd={handleAdd}
        addDataTour="campos-customizados-adicionar"
        onInactivate={handleExcluir}
        defaultFilters={{ filters: { situacao: "a" }, dateFilters: {} }}
        disableInactivateWhen={(row) => row.tem_respostas === "S"}
        disableInactivateTooltip="Não é possível excluir pois o campo customizado já foi utilizado."
      />

      <CamposCustomizadosModal
        show={showModal}
        handleClose={handleClose}
        campo={selectedCampo}
        entidadeId={entidadeID}
        fetchCampos={fetchCampos}
      />
    </div>
  );
};

export default CamposCustomizados;
